(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("xdsweakmap", [], factory);
	else if(typeof exports === 'object')
		exports["xdsweakmap"] = factory();
	else
		root["xdsweakmap"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return 